import BaseCommand from "@/models/api/commands/BaseCommand";

export class ChangeCorrectedDocumentNumberCommand extends BaseCommand {
  CommandName = "ChangeCorrectedDocumentNumber";
  Command: { Value: string | null };
  constructor(sessionId: string, operationId: string, value: string | null) {
    super(sessionId, operationId);
    this.Command = { Value: value };
  }
}
